import React from 'react';
import PropTypes from 'prop-types';
import { revealPreview, hookToForm } from './hookForm';
import './hooks.css';

// What the reader meets after a guess, rendered the way the app prints
// it. Shows the verdict for the ticked (correct) option, so it matches
// the tick above it. Takes either the edit form (live in the modal) or
// a saved hook.
export default function HookPreview({ form, hook, courseName, title }) {
    const preview = revealPreview(form || hookToForm(hook), courseName);
    const usesDefaultBridge = !((form ? form.bridge : hook?.bridge) || '').trim();
    return (
        <div className="hk-preview">
            {title && <div className="hk-preview-title">{title}</div>}
            <p>{preview.correct}</p>
            <p className={`hk-preview-bridge${usesDefaultBridge ? ' hk-preview-default' : ''}`}>{preview.bridge}</p>
        </div>
    );
}

HookPreview.propTypes = {
    form: PropTypes.shape({
        optionA: PropTypes.string,
        optionB: PropTypes.string,
        correctIndex: PropTypes.number,
        explanation: PropTypes.string,
        bridge: PropTypes.string,
    }),
    hook: PropTypes.shape({
        options: PropTypes.arrayOf(PropTypes.string),
        correct_index: PropTypes.number,
        explanation: PropTypes.string,
        bridge: PropTypes.string,
    }),
    courseName: PropTypes.string,
    title: PropTypes.string,
};

HookPreview.defaultProps = { form: null, hook: null, courseName: '', title: '' };
